/* eslint-disable no-shadow */
import { ContentDocumentLink } from 'src/app/models/content-document-link.model';
import * as fromActions from '../actions';

// State for Invoice Attachments
export interface InvoiceAttachmentState {
  entities: { [id: string]: ContentDocumentLink };
  loaded: boolean;
  loading: boolean;
}

export const initialState: InvoiceAttachmentState = {
  entities: {},
  loaded: false,
  loading: false,
};

export function reducer(
  state = initialState,
  action: fromActions.InvoiceAttachmentsAction,
): InvoiceAttachmentState {
  switch (action.type) {
    case fromActions.LOAD_INVOICE_ATTACHMENTS: {
      return {
        ...state,
        loading: true,
      };
    }

    case fromActions.LOAD_INVOICE_ATTACHMENTS_SUCCESS: {
      const files = action.payload;
      let entities = {};

      if (files !== null) {
        entities = files.reduce(
          (entities: { [id: string]: ContentDocumentLink }, file) => ({
            ...entities,
            [file.ContentDocumentId]: file,
          }),
          {
            ...state.entities,
          },
        );
      }

      return {
        ...state,
        loading: false,
        loaded: true,
        entities,
      };
    }

    case fromActions.LOAD_INVOICE_ATTACHMENTS_FAIL: {
      return {
        ...state,
        loading: false,
        loaded: false,
      };
    }

    case fromActions.CLEAR_INVOICE_ATTACHMENTS: {
      return initialState;
    }

    default: {
      return state;
    }
  }
}

export const getInvoiceAttachmentEntities = (state: InvoiceAttachmentState) =>
  state.entities;
export const getInvoiceAttachmentLoading = (state: InvoiceAttachmentState) =>
  state.loading;
export const getInvoiceAttachmentLoaded = (state: InvoiceAttachmentState) =>
  state.loaded;
